import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EditDealOperations, Operation } from './operations';
import { getOperations, cancelContract, cancelOperation } from '../../../../redux/actions/contractAction';
import { getListUsers } from '../../../../redux/actions/userAction';
import {
  EDIT_DEAL_PURITY_POSITIONS_OPERATION,
  EDIT_DEAL_THING_POSITIONS_OPERATION,
  EDIT_DEAL_CAR_POSITIONS_OPERATION,
  typeOperations
} from '../../../../helpers/data-constants';
import Loader from './Loader/Loader';

import './layoutOperations.scss';
import '../../../../assets/styles/components/_contracts-timeline.scss';

const LayoutOperations = ({ contractId, clientContract, type }) => {
  const { operations, isTabLoading } = useSelector(({ contract }) => contract);
  const { listUsers, isLoading } = useSelector(({ user }) => user);
  const dispatch = useDispatch();

  const [complementsData, setComplementsData] = useState([]);

  useEffect(() => {
    dispatch(getOperations(contractId));
  }, [dispatch, contractId]);

  useEffect(() => {
    if (operations && operations.length !== 0 && listUsers) {
      setComplementsData(
        operations.map((i) => {
          if (i.hasOwnProperty('revertedOperations')) {
            return {
              ...i,
              userFullName: listUsers.find((user) => user.id === i.userId)
                ? listUsers.find((user) => user.id === i.userId).fullName
                : null,
              revertedOperations: i.revertedOperations.map((item) => ({
                ...item,
                userFullName: listUsers.find((user) => user.id === item.userId)
                  ? listUsers.find((user) => user.id === item.userId).fullName
                  : null,
              })),
            };
          } else {
            return {
              ...i,
              userFullName: listUsers.find((user) => user.id === i.userId)
                ? listUsers.find((user) => user.id === i.userId).fullName
                : null,
            };
          }
        }),
      );
    }
  }, [dispatch, operations, listUsers]);

  useEffect(() => {
    if (operations.length !== 0) {
      const arrRevertedOperations = operations.filter((i) =>
        i.hasOwnProperty('revertedOperations'),
      );
      let listUsers;

      if (arrRevertedOperations.length !== 0) {
        const userId = arrRevertedOperations
          .map((i) => i.revertedOperations.map((item) => item.userId))
          .flat(Infinity);
        listUsers = [
          ...new Set(
            operations.map(({ userId }) => userId),
            ...userId,
          ),
        ].join(',');
      } else {
        listUsers = [...new Set(operations.map(({ userId }) => userId))].join(',');
      }

      dispatch(getListUsers(listUsers));
    }
  }, [operations, dispatch]);

  const cancelOperations = (data) => {
    dispatch(cancelOperation(data));
  };

  const cancelNewDeal = () => {
    const payload = {dealId: contractId, unnecessary: 'true'}
    dispatch(cancelContract(payload));
  };

  const returnViewLayout = (arrayOperations) => {
    return arrayOperations.map((i, ind) => {
      if (typeOperations[i.type]) {
        if (typeOperations[i.type].param) {
          if (i.type === typeOperations[EDIT_DEAL_PURITY_POSITIONS_OPERATION].param
                  || i.type === typeOperations[EDIT_DEAL_THING_POSITIONS_OPERATION].param
                  || i.type === typeOperations[EDIT_DEAL_CAR_POSITIONS_OPERATION].param) {
            return (
              <EditDealOperations
                key={i.date + ind}
                dataOperation={i}
                cancelOperation={cancelOperations}
                clientContract={clientContract}
                type={type}
              />
            );
          } else {
            return (
              <Operation 
                key={i.date + ind} 
                dataOperation={i} 
                cancelOperation={cancelOperations}
                cancelNewDeal={cancelNewDeal} 
              />
            );
          }
        } else {
          return null;
        }
      } else {
        return <p key={i.date + ind}>Операция не определена</p>;
      }
    });
  };

  return (
    <fieldset className="m-t-spacer-2">
      <div className="contracts-timeline">
        {isTabLoading || isLoading ? (
          <Loader />
        ) : (
          complementsData && complementsData.length !== 0 && returnViewLayout(complementsData)
        )}
      </div>
    </fieldset>
  );
};

export default LayoutOperations;
